// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'workers'

/**
 * Worker Model Interface (auto-generated from Drizzle schema)
 */
export interface WorkerModel {
  id: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  status: string
  lastHeartbeat: string
  currentExecutionId: string
  capabilities: string[]
  mode: string
  hostname: string
  ip?: string
  healthPort?: number
  maxConcurrent: number
  pollIntervalMs: number
  registeredAt: string
  registeredBy: string
  version?: string
  createdAt: string
  updatedAt: string
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "status": {
          "type": "string",
          "maxLength": 20
      },
      "lastHeartbeat": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "currentExecutionId": {
          "type": "string",
          "maxLength": 100
      },
      "capabilities": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "mode": {
          "type": "string",
          "maxLength": 20
      },
      "hostname": {
          "type": "string",
          "maxLength": 200
      },
      "ip": {
          "type": "string",
          "maxLength": 200
      },
      "healthPort": {
          "type": "integer",
          "minimum": 0,
          "maximum": 65535,
          "multipleOf": 1
      },
      "maxConcurrent": {
          "type": "integer",
          "minimum": 1,
          "maximum": 1000,
          "multipleOf": 1
      },
      "pollIntervalMs": {
          "type": "integer",
          "minimum": 100,
          "maximum": 3600000,
          "multipleOf": 1
      },
      "registeredAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "registeredBy": {
          "type": "string",
          "maxLength": 200
      },
      "version": {
          "type": "string",
          "maxLength": 200
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "name",
      "status",
      "lastHeartbeat",
      "capabilities",
      "mode",
      "hostname",
      "maxConcurrent",
      "pollIntervalMs",
      "registeredAt",
      "registeredBy",
      "createdAt",
      "updatedAt",
      "currentExecutionId"
  ],
  indexes: [
      [
          "status",
          "lastHeartbeat"
      ],
      [
          "lastHeartbeat"
      ],
      [
          "currentExecutionId"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
